export default `
  fragment OrderFragment on Order {
    id
    items {
        id
        type
        quantity
        price
        meta {
            name
            gender
            weight
            interval
            products {
                id
                name
            }
        }
    }
    discountCode
    billingAddress
    billingContact {
      name
      email
      phone
    }
    shippingAddress
    subtotal
    subtotalDiscountAmount
    totalDiscountAmount
    tax
    total
    status
    meta {
      subscriptionStartDate
      firstDeliveryDate
      billingCycleStartDate
    }
    createdAt
    updatedAt
  }
`;
